import axiosInstance from '../../utils/axiosInstance';
import endpoints from '../../utils/endpoints';

const getReport = async (district) => {
  const params =
    district && String(district).trim()
      ? { district: String(district).trim() }
      : {};
  const { data } = await axiosInstance.get(endpoints.statisticsReport, { params });
  return data;
};

export default { getReport };
